import { PayloadAction, createAction } from "typesafe-actions";

import { ViewsApp } from "./views.store";

export const swapViewAction: (data: ViewsApp) => PayloadAction<"view/swap", ViewsApp> =
  createAction("view/swap")<ViewsApp>();
